export const translations = {
  ques20: {
    EN: {
      title: "Agreement of Policies",
      acknowledgement:
        "I, {name}, acknowledge and agree to participate in the online video interview conducted by Northstarz.Ai developed by Novelio Technologies Private Limited. I understand that the purpose of this interview is for evaluation in relation to the job position posted by {compName.name}.",
      consent:
        "By participating in this video interview, I consent to the collection, use, and sharing of my video and personal information, including but not limited to my name, email address, and location, with the employer who posted the job for which I have applied.",
      employerUse:
        "I understand that the employer will use this information solely for the purpose of evaluating my suitability for the job position and may retain this information for future reference. I also acknowledge that Novelio Technologies Private Limited is not responsible for the employer's use of my information once shared.",
      terms:
        "I have read and understood the terms of this consent form and agree to abide by them.",
      nextButton: "Next",
    },
    HI: {
      title: "नीतियों का समझौता",
      acknowledgement:
        "मैं, {name}, सहमति देता/देती हूँ और Novelio Technologies Private Limited द्वारा बनाए गए Northstarz.Ai द्वारा आयोजित ऑनलाइन वीडियो साक्षात्कार में भाग लेने के लिए सहमत हूँ। मैं समझता/समझती हूँ कि इस साक्षात्कार का उद्देश्य {compName.name} द्वारा पोस्ट किए गए नौकरी के पद के लिए मेरा मूल्यांकन करना है।",
      consent:
        "इस वीडियो साक्षात्कार में भाग लेकर, मैं अपनी वीडियो और व्यक्तिगत जानकारी जैसे नाम, ईमेल पता और स्थान को एकत्र करने, उपयोग करने और साझा करने की अनुमति देता/देती हूँ।",
      employerUse:
        "मैं समझता/समझती हूँ कि नियोक्ता इस जानकारी का उपयोग केवल नौकरी के लिए मेरी उपयुक्तता का मूल्यांकन करने के लिए करेगा और भविष्य में इस जानकारी को रख सकता है। मैं यह भी मानता/मानती हूँ कि Novelio Technologies Private Limited मेरी जानकारी के नियोक्ता द्वारा उपयोग के लिए जिम्मेदार नहीं है।",
      terms:
        "मैंने इस सहमति पत्र की शर्तों को पढ़ लिया है, समझ लिया है और उनसे सहमत हूँ।",
      nextButton: "आगे",
    },
    MS: {
      title: "Perjanjian Dasar",
      acknowledgement:
        "Saya, {nama}, mengakui dan bersetuju untuk mengambil bahagian dalam temu bual video dalam talian yang dijalankan oleh Northstarz.Ai yang dibangunkan oleh Novelio Technologies Private Limited. Saya faham bahawa tujuan temu duga ini adalah untuk penilaian berhubung dengan jawatan kerja yang disiarkan oleh {compName.name}.",
      consent:
        "Dengan mengambil bahagian dalam temu bual video ini, saya membenarkan pengumpulan, penggunaan dan perkongsian video dan maklumat peribadi saya, termasuk tetapi tidak terhad kepada nama, alamat e-mel dan lokasi saya, dengan majikan yang menyiarkan pekerjaan yang saya telah memohon.",
      employerUse:
        "Saya faham bahawa majikan akan menggunakan maklumat ini semata-mata untuk tujuan menilai kesesuaian saya untuk jawatan kerja dan mungkin menyimpan maklumat ini untuk rujukan masa hadapan. Saya juga mengakui bahawa Novelio Technologies Private Limited tidak bertanggungjawab terhadap penggunaan maklumat saya oleh majikan setelah dikongsi.",
      terms:
        "Saya telah membaca dan memahami syarat borang persetujuan ini dan bersetuju untuk mematuhinya.",
      nextButton: "Seterusnya",
    },
  },
  ques0: {
    EN: {
      instructionsTitle: "Instructions",
      recordingInstructionsTitle: "Instructions for Recording:",
      recordingInstructions: [
        "Use a phone/computer with a camera",
        "Allow permissions to record when prompted",
        "Sit in a quiet place",
        "Ensure sufficient light on your face",
        "Speak clearly and slowly",
      ],
      testingInstructionsTitle: "How you will be tested?",
      testingInstructions: [
        "This is an automatic video interview",
        "Click on Start Recording after reading the question",
        "After answering click on STOP and then SUBMIT",
        "Complete all answers to get your report",
      ],
      nextButton: "Start the Interview",
    },
    HI: {
      instructionsTitle: "निर्देश",
      recordingInstructionsTitle: "रिकॉर्डिंग के निर्देश:",
      recordingInstructions: [
        "कैमरा वाले फोन/कंप्यूटर का उपयोग करें",
        "रिकॉर्ड करने की अनुमति दें",
        "एक शांत जगह पर बैठें",
        "अपने चेहरे पर पर्याप्त रोशनी रखें",
        "स्पष्ट और धीरे बोलें",
      ],
      testingInstructionsTitle: "परीक्षण कैसे होगा?",
      testingInstructions: [
        "यह एक स्वचालित वीडियो साक्षात्कार है",
        "प्रश्न पढ़ने के बाद रिकॉर्डिंग शुरू करें",
        "उत्तर देने के बाद स्टॉप और फिर सबमिट करें",
        "अपनी रिपोर्ट पाने के लिए सभी उत्तर पूरे करें",
      ],
      nextButton: "साक्षात्कार शुरू करें",
    },
    MS: {
      instructionsTitle: "Arahan",
      recordingInstructionsTitle: "Arahan untuk Rakaman:",
      recordingInstructions: [
        "Gunakan telefon/komputer dengan kamera",
        "Benarkan kebenaran untuk merakam apabila digesa",
        "Duduk di tempat yang sunyi",
        "Pastikan cahaya yang mencukupi pada muka anda",
        "Bercakap dengan jelas dan perlahan",
      ],

      testingInstructionsTitle: "Bagaimana anda akan diuji?",
      testingInstructions: [
        "Ini adalah wawancara video automatik",
        "Klik pada Mula Rakaman selepas membaca soalan",
        "Selepas menjawab klik pada STOP dan kemudian SUBMIT",
        "Lengkapkan semua jawapan untuk mendapatkan laporan anda",
      ],
      nextButton: "Mulakan Temuduga",
    },
  },
  ques21: {
    EN: {
      title: "Interview Set-up",
      instructionsTitle: "Instructions",
      videoCheck: "Video Check",
      recordingInstructionsTitle: "How you will be tested?",
      recordingInstructions: [
        "You will be asked questions on Improve Critical Thinking, Language & Articulation, Team Play, Leadership and Confidence",
        "Expected Time: 10-15 mins",
      ],
      testingInstructionsTitle: "How you will be tested?",
      testingInstructions: [
        "Please use a phone/computer with a camera and a microphone",
        "Ensure to give the necessary permissions to allow recording if prompted",
        "Please make sure there is no background noise",
        "Try to sit in a place with sufficient light",
        "It is better to use a headphone for clear voice",
        "Try to speak slowly and clearly for audio clarity",
      ],
      nextButton: "Start When You Ready",
    },
    HI: {
      title: "इंटरव्यू सेट-अप",
      instructionsTitle: "निर्देश",
      videoCheck: "वीडियो चेक",
      recordingInstructionsTitle: "आपकी कैसे परीक्षा होगी?",
      recordingInstructions: [
        "आपसे प्रश्न पूछे जाएंगे जैसे: क्रिटिकल थिंकिंग, भाषा और उच्चारण, टीम प्ले, नेतृत्व और आत्मविश्वास पर",
        "अपेक्षित समय: 10-15 मिनट",
      ],
      testingInstructionsTitle: "आपकी कैसे परीक्षा होगी?",
      testingInstructions: [
        "कृपया ऐसा फोन/कंप्यूटर उपयोग करें जिसमें कैमरा और माइक्रोफोन हो",
        "रिकॉर्डिंग की अनुमति देने के लिए आवश्यक अनुमतियाँ प्रदान करें, यदि पूछा जाए",
        "कृपया ध्यान दें कि कोई पृष्ठभूमि शोर न हो",
        "कोशिश करें कि आप एक ऐसी जगह बैठें जहाँ पर्याप्त रोशनी हो",
        "स्पष्ट आवाज के लिए हेडफोन का उपयोग करना बेहतर है",
        "ऑडियो स्पष्टता के लिए धीरे और स्पष्ट बोलें",
      ],
      nextButton: "तैयार होने पर शुरू करें",
    },
    MS: {
      title: "Persediaan Temuduga",
      instructionsTitle: "Arahan",
      videoCheck: "Semakan Video",
      recordingInstructionsTitle: "Bagaimana anda akan diuji?",
      recordingInstructions: [
        "You will be asked questions on Improve Critical Thinking, Language & Articulation, Team Play, Leadership and Confidence",
        "Expected Time: 10-15 mins",
      ],
      testingInstructionsTitle: "How you will be tested?",
      testingInstructions: [
        "Please use a phone/computer with a camera and a microphone",
        "Ensure to give the necessary permissions to allow recording if prompted",
        "Please make sure there is no background noise",
        "Try to sit in a place with sufficient light",
        "It is better to use a headphone for clear voice",
        "Try to speak slowly and clearly for audio clarity",
      ],
      nextButton: "Start When You Ready",
    },
  },
  instruction: {
    EN: {
      s1: "Recording",
      s2: "Record Now",
      s3: "Stop recording",
      s4: "If you are unable to see your video,",
      s5: "Submit",
      s6: "Question",
      s7: "Please share the following important information to take your application forward.",
      s8: "Completed",
      s9: "Recording Will Automatically Start in ..",
    },
    HI: {
      s1: "रिकॉर्डिंग",
      s2: "रिकॉर्डिंग शुरू करें",
      s3: "रिकॉर्डिंग बंद करें",
      s4: "अगर आप अपना वीडियो नहीं देख पा रहे हैं,",
      s5: "सबमिट करें",
      s6: "प्रश्न",
      s7: "कृपया आवेदन आगे बढ़ाने के लिए निम्नलिखित जानकारी दें।",
      s8: " पूरा हो गया",
      s9: "रिकॉर्डिंग स्वचालित रूप सेप्रारंभ हो जाएगी..",
    },
    MS: {
      s1: "Recording",
      s2: "Record Now",
      s3: "Stop recording",
      s4: "If you are unable to see your video,",
      s5: "Submit",
      s6: "Question",
      s7: "Please share the following important information to take your application forward.",
      s8: "Completed",
      s9: "Recording Will Automatically Start in ..",
    },
  },
  info: {
    EN: {
      s1: "Super! You have completed your answers. Give us a few moments to upload your answers to our knowledge cloud.",
      s2: "Pro Tip",
      s3: "Thank you for taking this interview",
      s4: "If shortlisted, we will email you the next steps in the coming few days.",
      s5: " Rate your experience",
      s6: "You are awesome! Your feedback will help us become even better.",

      s7: "What would you like us to do better?",
      s8: "Job Application Details",
      currentNoticePeriod: "Current Notice Period",
      inDays: "In days",
      approximateJoiningTime: "Approximate Joining Time",
      currentMonthlySalary: "Current Annual Salary",
      expectedMonthlySalary: "Expected Annual Salary",
      additionalInfo: "Additional Info",
      addMessage:
        "Any other information that will make us understand you better...",
      saveAndNext: "Submit",
    },
    HI: {
      s1: "सुपर! आपने अपने उत्तर पूरे कर लिए हैं। कृपया हमें कुछ समय दें ताकि हम आपके उत्तरों को हमारे ज्ञान क्लाउड में अपलोड कर सकें।",
      s2: "विशेष सुझाव",
      s3: "इस इंटरव्यू के लिए आपका धन्यवाद",
      s4: "अगर आपका चयन हुआ, तो हम आपको अगले कुछ दिनों में ईमेल के द्वारा अगले कदमों के बारे में बताएंगे।",
      s5: "अपने अनुभव को मूल्यांकित कीजिए।",
      s6: "आपकी प्रतिक्रिया हमें और भी बेहतर बनने में मदद करेगी।",
      s7: "आप हमसे क्या चाहते हैं कि हम बेहतर करें?",
      s8: "नौकरी एप्लिकेशन डिटेल्स",
      currentNoticePeriod: "वर्तमान नोटिस अवधि",
      inDays: "दिनों में",
      approximateJoiningTime: "अनुमानित शामिल होने का समय",
      currentMonthlySalary: "वर्तमान वार्षिक वेतन",
      expectedMonthlySalary: "अपेक्षित वार्षिक वेतन",
      additionalInfo: "अतिरिक्त जानकारी",
      addMessage:
        "कोई अन्य जानकारी जो हमें आपको बेहतर ढंग से समझने में मदद करेगी...",
      saveAndNext: "फॉर्म जमा करें",
    },
    MS: {
      s1: "Super! You have completed your answers. Give us a few moments to upload your answers to our knowledge cloud.",
      s2: "Pro Tip",
      s3: "Thank you for taking this interview",
      s4: "If shortlisted, we will email you the next steps in the coming few days.",
      s5: " Rate your experience",
      s6: "You are awesome! Your feedback will help us become even better.",

      s7: "What would you like us to do better?",
      s8: "Job Application Details",
      currentNoticePeriod: "Current Notice Period",
      inDays: "In days",
      approximateJoiningTime: "Approximate Joining Time",
      currentMonthlySalary: "Current Annual Salary",
      expectedMonthlySalary: "Expected Annual Salary",
      additionalInfo: "Additional Info",
      addMessage:
        "Any other information that will make us understand you better...",
      saveAndNext: "Submit",
    },
  },
};
